<template>
  <div class="section">
    <div class="container">
      <div class="row">
        <div class="col-md-6 col-12 credit-description">
          <div>
            <i class="fas fa-coins"></i>
          </div>
          <div
            class="credit-text"
          >1 credit gives you the ability to download 1 exclusive, high resolution image from any artist on Art Grab.</div>
        </div>
        <div class="col-md-6 col-12 credit-description">
          <div>
            <i class="fas fa-stopwatch"></i>
          </div>
          <div class="credit-text">Credits do not expire. Buy them now, use them when you're ready.</div>
        </div>
        <div class="col-md-6 offset-md-3 col-12 credit-description">
          <div>
            <i class="fas fa-question-circle"></i>
          </div>
          <div class="credit-text">
            Still have questions about how our credits system works? Please
            <router-link to="/contact">contact us</router-link>.
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "credits-description"
};
</script>

<style scoped lang="scss">
.credit-description {
  display: flex;
  flex-direction: column;
  margin-top: 2rem;
  align-items: center;
  justify-content: center;
  text-align: center;

  .credit-text {
    width: 78%;
    font-weight: 600;
  }

  i {
    font-size: 3rem;
    margin-bottom: 1rem;
    color: #ccc;
  }
}
</style>
